<div class="date-picker" #datepicker>
  <div class="div-calendar-icon" (click)="!disabled ? toggleCalendar() : ''">
    <lib-elux-icon class="calendar-icon" [icon]="'Calendar.svg'" [color]="'#011E41'" [size]="'24'" [sizeType]="'px'" />
  </div>
  <input
    [value]="formatedDate"
    (change)="onChangeValue($event)"
    [id]="idInput"
    [disabled]="disabled"
    [placeholder]="placeholder"
    maxlength="10"
    type="text"
    (blur)="onBlur()"
    (focus)="closeCalendar()"
  />
  <div class="calendar" *ngIf="showCalendar">
    <div class="calendar-header">
      <div class="previous" (click)="previous()">
        <lib-elux-icon [hidden]="isPreviousDisabled()" [icon]="'Chevron_Left.svg'" [size]="'22'" [sizeType]="'px'" />
      </div>
      <span (click)="changeView()">{{ pickerView === 'week' ? headerDate() : currentDate.getFullYear() }}</span>
      <div class="next" (click)="next()">
        <lib-elux-icon [hidden]="isNextDisabled()" [icon]="'Chevron_Right.svg'" [size]="'22'" [sizeType]="'px'" />
      </div>
    </div>
    <div class="calendar-body" *ngIf="pickerView === 'week'">
      <div class="day-labels">
        <span *ngFor="let day of headerDateWeek()">{{ day }}</span>
      </div>
      <ng-container *ngFor="let day of days">
        <div
          class="day"
          [ngClass]="{ disabled: day.disabled, today: day.today, selected: day.selected }"
          (click)="day.disabled ? null : selectDate(day)"
        >
          <span>{{ day.day }}</span>
        </div>
      </ng-container>
    </div>
    <div class="year-body" *ngIf="pickerView === 'year'">
      <ng-container *ngFor="let year of years">
        <div class="year" *ngIf="!year.disabled" (click)="!year.disabled && selectYear(year.value)">
          {{ year.value }}
        </div>
      </ng-container>
    </div>
    <div class="month-body" *ngIf="pickerView === 'month'">
      <ng-container *ngFor="let month of months">
        <div class="month" *ngIf="!month.disabled" (click)="!month.disabled && selectMonth(month.value)">
          {{ month.text }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
